import React, { createContext, useState, useEffect } from 'react';
import axios from 'axios';

interface User {
  email: string;
  name: string;
  store_id: string;
}

interface AuthContextProps {
  user: User | null;
  setUser: (user: User | null) => void;
  logout: () => void;
  loading: boolean;
}

export const AuthContext = createContext<AuthContextProps>({
  user: null,
  setUser: () => {},
  logout: () => {},
  loading: true,
});

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('authToken');
    if (token) {
      axios
        .get('https://api.thunderbirdsmoke.net/auth/validate-token', {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((response) => {
          const { name, email, location_id } = response.data.user;
          
          // ✅ Default store_id to 1 if missing
          const storeId = location_id || 1;

          setUser({ name, email, store_id: storeId });

          localStorage.setItem("store_id", storeId);
        })
        .catch(() => {
          localStorage.removeItem('authToken');
          setUser(null);
        })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const logout = () => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('store_id'); // ✅ Remove store_id on logout
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};
